import { SvelteComponent, init, safe_not_equal, element, create_component, attr, insert, mount_component, noop, transition_in, transition_out, detach, destroy_component, create_slot, space, append, listen, group_outros, check_outros, update_slot_base, get_all_dirty_from_scope, get_slot_changes, add_render_callback, create_in_transition } from '../../../../external_node_modules/svelte/internal/index.mjs.js';
import { fade } from '../../../../external_node_modules/svelte/transition/index.mjs.js';
import { disableBodyOverflow } from '../../../../utils/disableBodyOverflow.js';
import { updateBrowserControlState } from '../../../../external_node_modules/@wg/web2clientapi/browser/updateBrowserControlState.js';
import EscButton from '../EscButton/EscButton.svelte.js';
import objectToStyle from '../../../../utils/objectToStyle.js';
import settings from '../../../../settings.js';
import './Popup.css.js';

/* src/ui/shared/components/Popup/Popup.svelte generated by Svelte v3.44.2 */

function create_if_block(ctx) {
	let div;
	let escbutton;
	let current;

	escbutton = new EscButton({
			props: { handleClick: /*destroyPopup*/ ctx[2] }
		});

	return {
		c() {
			div = element("div");
			create_component(escbutton.$$.fragment);
			attr(div, "class", "popup-close wcl-1vbrgc2");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			mount_component(escbutton, div, null);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(escbutton.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(escbutton.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_component(escbutton);
		}
	};
}

function create_fragment(ctx) {
	let div1;
	let div0;
	let t;
	let div1_intro;
	let current;
	let mounted;
	let dispose;
	let if_block = /*closePopup*/ ctx[0] && create_if_block(ctx);
	const default_slot_template = /*#slots*/ ctx[6].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[5], null);

	return {
		c() {
			div1 = element("div");
			div0 = element("div");
			if (if_block) if_block.c();
			t = space();
			if (default_slot) default_slot.c();
			attr(div0, "class", "popup-content wcl-1vbrgc2");
			attr(div1, "class", "popup wcl-1vbrgc2");
			attr(div1, "style", /*popupStyles*/ ctx[1]);
		},
		m(target, anchor) {
			insert(target, div1, anchor);
			append(div1, div0);
			if (if_block) if_block.m(div0, null);
			append(div0, t);

			if (default_slot) {
				default_slot.m(div0, null);
			}

			current = true;

			if (!mounted) {
				dispose = listen(window, "keydown", /*handleKeydown*/ ctx[3]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (/*closePopup*/ ctx[0]) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty & /*closePopup*/ 1) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(div0, t);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}

			if (default_slot) {
				if (default_slot.p && (!current || dirty & /*$$scope*/ 32)) {
					update_slot_base(
						default_slot,
						default_slot_template,
						ctx,
						/*$$scope*/ ctx[5],
						!current
						? get_all_dirty_from_scope(/*$$scope*/ ctx[5])
						: get_slot_changes(default_slot_template, /*$$scope*/ ctx[5], dirty, null),
						null
					);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			transition_in(default_slot, local);

			if (!div1_intro) {
				add_render_callback(() => {
					div1_intro = create_in_transition(div1, fade, { duration: 350 });
					div1_intro.start();
				});
			}

			current = true;
		},
		o(local) {
			transition_out(if_block);
			transition_out(default_slot, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div1);
			if (if_block) if_block.d();
			if (default_slot) default_slot.d(detaching);
			mounted = false;
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { $$slots: slots = {}, $$scope } = $$props;
	let { isClosable } = $$props;
	let { closePopup } = $$props;

	const defaultStyles = {
		'z-index': 2147483608,
		'background-color': 'rgba(0, 0, 0, 0.9)'
	};

	const popupStyles = objectToStyle(Object.assign({}, defaultStyles, settings.customPopupStyles));

	function destroyPopup() {
		updateBrowserControlState(false);
		disableBodyOverflow(false);
		closePopup();
	}

	function handleKeydown(e) {
		if (isClosable && e.key === 'Escape') {
			destroyPopup();
		}
	}

	updateBrowserControlState(true);
	disableBodyOverflow(true);

	$$self.$$set = $$props => {
		if ('isClosable' in $$props) $$invalidate(4, isClosable = $$props.isClosable);
		if ('closePopup' in $$props) $$invalidate(0, closePopup = $$props.closePopup);
		if ('$$scope' in $$props) $$invalidate(5, $$scope = $$props.$$scope);
	};

	return [
		closePopup,
		popupStyles,
		destroyPopup,
		handleKeydown,
		isClosable,
		$$scope,
		slots
	];
}

class Popup extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { isClosable: 4, closePopup: 0 });
	}
}

export { Popup as default };
//# sourceMappingURL=Popup.svelte.js.map
